import bannerImage from '/assets/images/payment-methods-page-images/icon-contract.svg';
import LegalBanner from "../../components/privacy-policy-page-components/legal-banner/LegalBanner.tsx";
import {PaymentMethodsDemonstrationsCardsConfig} from "../../configs/payment-methods-page/paymentMethodsDemonstrationsCards.ts";
import DemonstrationsCards from "../../components/demonstrations/DemonstrationsCards.tsx";
import SinglePaymentMethodDescriptionSection
    from "../../components/single-payment-method-page-components/single-payment-method-description-section/SinglePaymentMethodDescriptionSection.tsx";
import {InstallmentPaymentsDescriptionSectionConfig} from "../../configs/payment-methods-page/installmentPaymentsDescriptionSection.ts";
import GetStartedBanner from "../../components/home-page-components/get-started-banner/GetStartedBanner.tsx";
import CustomHelmet from "../../components/helmet/CustomHelmet.tsx";

const InstallmentPaymentsPage = () => {
    return (
        <>
            <CustomHelmet title={'titles.installment_payments'} />
            <LegalBanner heading={'installment_purchases_service'} image={bannerImage} />
            <DemonstrationsCards config={PaymentMethodsDemonstrationsCardsConfig} />
            <SinglePaymentMethodDescriptionSection config={InstallmentPaymentsDescriptionSectionConfig} />
            <GetStartedBanner bannerText={'payment_methods_banner_text'}
                              linkTo={'routes.pricing'}
                              linkClassname={'opy-button opy-button--white opy-button--medium text-center'}
                              linkText={'get_prices'} />
        </>
    )
}

export default InstallmentPaymentsPage;
